<template>
  <div>
    <TopLabel v-if="isShowTopLabel">{{ topLabel }}</TopLabel>
    <CheckboxMultiple
      v-model="handleInputValue"
      :checkbox-id="checkboxId"
      class="checkboxComponent"
      :disabled="disabled"
      @change="clicked"
    >
      <span class="label" :class="{ disabled: disabled }">{{ label }}</span>
    </CheckboxMultiple>
  </div>
</template>

<script>
import TopLabel from '../Text/InputLabel.vue';
import CheckboxMultiple from '../CheckboxMultiple.vue';

export default {
  name: 'CheckboxArea',
  components: {
    TopLabel,
    CheckboxMultiple,
  },
  model: {
    prop: 'inputValue',
    event: 'change',
  },
  props: {
    topLabel: {
      type: String,
      required: false,
      default: '',
    },
    label: {
      type: String,
      required: true,
    },
    inputValue: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
    checkboxId: {
      type: String,
      required: true,
    },
  },
  computed: {
    isShowTopLabel() {
      return Boolean(this.topLabel);
    },
    handleInputValue: {
      get() {
        return this.inputValue;
      },
      set(value) {
        this.$emit('change', value);
      },
    },
  },
  methods: {
    changeState(isChecked) {
      this.$emit('change-checkbox-state', isChecked);
    },
    clicked() {
      this.$emit('change');
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'css/contents/common/global';

.checkboxComponent {
  margin-bottom: 4px;
}

.label {
  color: $color-text-primary;
  margin-left: 28px;
  font-size: $text-size-paragraph2;
  line-height: $text-line-height-default;

  &.disabled {
    color: #afb8be;
  }
}
</style>
